import { Card } from '@sandtech-hub-monorepo/ui-kit';
import { ProgramOverviewCard } from './ProgramOverviewCard';
import { PlannedCoursesView } from '@sandtech-hub-monorepo/ui-kit-site';
import { Application, Enrollment } from '../types';

interface Props {
  enrollment: Enrollment;
  application?: Application;
}

export const PendingApplicationView = ({ enrollment, application }: Props) => {
  return (
    <Card className="px-6 py-9">
      <ProgramOverviewCard enrollment={enrollment} application={application} />
      <div className="border border-border rounded-lg mt-8 p-4">
        <PlannedCoursesView
          plannedCourses={enrollment.plannedCourses}
          isUniversityProgram={enrollment.program.isUniversityProgram}
        />
      </div>
    </Card>
  );
};
